
  import Pagination from '@/components/Pagination';
  import RatingDialog from '@/components/sections/RatingDialog';

  export default {
    name: 'RatingListDesktop',
    components: {
      Pagination,
      RatingDialog,
    },
    props: {
      showInDialog: {
        type: Boolean,
        required: true,
      },
      reviews: {
        type: Array,
        required: true,
      },
      averageRating: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        page: 1,
        numReviews: 5,
      };
    },
    computed: {
      visibleReviews() {
        return this.reviews.slice(
          (this.page - 1) * this.numReviews,
          this.page * this.numReviews
        );
      },
    },
  };
